import React from 'react';

const Stats = () => {
    return (
        <div className="stats flex flex-col md:flex-row bg-sky-800/20 shadow w-full min-h-full">
            <div className="stat ">
                <div className="stat-figure text-[#004d7a]">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        className="inline-block h-8 w-8 stroke-current">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                    </svg>
                </div>
                <div className="stat-title text-[#004d7a]">Happy Customers</div>
                <div className="stat-value text-[#004d7a]">20.0K</div>
                <div className="stat-desc text-[#004d7a]">21% more than last month</div>
            </div>

            <div className="stat">
                <div className="stat-figure text-[#004d7a]">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        className="inline-block h-8 w-8 stroke-current">
                        <path d="m3.503 6.726c1.765-2.836 4.911-4.726 8.495-4.726 5.518 0 9.997 4.48 9.997 9.997 0 5.519-4.479 9.999-9.997 9.999-5.245 0-9.553-4.048-9.966-9.188-.024-.302.189-.811.749-.811.391 0 .715.3.747.69.351 4.369 4.012 7.809 8.47 7.809 4.69 0 8.497-3.808 8.497-8.499 0-4.689-3.807-8.497-8.497-8.497-3.037 0-5.704 1.597-7.206 3.995l1.991.005c.414 0 .75.336.75.75s-.336.75-.75.75h-4.033c-.414 0-.75-.336-.75-.75v-4.049c0-.414.336-.75.75-.75s.75.335.75.75zm7.487.021.007 5.563c0 .288.165.55.424.675l3.978 1.928c.373.18.821.024 1.001-.349s.024-.821-.349-1.001l-3.555-1.725s-.006-5.093-.006-5.093c0-.414-.337-.749-.75-.749-.414 0-.75.337-.75.751z"
                            fillRule="nonzero" />
                    </svg>
                </div>
                <div className="stat-title text-[#004d7a]">Years of experience</div>
                <div className="stat-value text-[#004d7a]">+42</div>
            </div>

            <div className="stat">
                <div className="stat-figure text-[#004d7a]">
                    <div className="stat-figure text-[#004d7a]">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            className="inline-block h-8 w-8 stroke-current">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                        </svg>
                    </div>
                </div>
                <div className="stat-value text-[#004d7a]">95%</div>
                <div className="stat-title text-[#004d7a]">Positive Reviews</div>
                <div className="stat-desc text-[#004d7a]">32% more than last month</div>
            </div>
        </div>
    );
};

export default Stats;